/* eslint-disable prettier/prettier */

import { logout as performLogout } from "../../utils/logoutUtils";

const createHistory = require("history").createBrowserHistory;

const useLogout = () => {
  const history = createHistory({ forceRefresh: true });

  const logout = async () => {
    await performLogout();
    history.push("/");
  };

  return { logout };
};

export default useLogout;